import { getUnixTime, parseISO, subYears } from 'date-fns';

import { ZipCode } from '@arrived/models';
import { useZillowPriceByZipCodeQuery } from '@arrived/queries';

import { StaticErrorView } from '../StaticErrorView';
import { Point, TimeSeriesGraphView } from './TimeSeriesGraphView';

interface ZillowHomePriceByZipCodeGraphProps {
  className?: string;
  height?: number;
  zipCode: ZipCode;
}

// Arbitrary choice of "years ago" open to modifications from the team
export const TWELVE_YEARS_AGO = subYears(Date.now(), 12);

export const ZillowHomePriceByZipCodeGraph = ({ zipCode, height, className }: ZillowHomePriceByZipCodeGraphProps) => {
  const { status, error, data } = useZillowPriceByZipCodeQuery(zipCode, TWELVE_YEARS_AGO);

  if (status === 'error') {
    return <StaticErrorView error={error} />;
  }

  const homeValues: Point[] = (data || []).map(
    (d): Point => ({
      x: getUnixTime(parseISO(d.date)),
      y: d.price,
    })
  );

  return <TimeSeriesGraphView className={className} height={height} rawData={homeValues} />;
};
